import { Length } from "../baseQuantities/length";
import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Density } from "../baseQuantities/density";
import { Viscosity } from "../baseQuantities/viscosity";
import { Velocity } from "../baseQuantities/velocity";
import { UnitLess } from "../baseQuantities/unitLess";

const standardMode: CalcMode = {
  id: "001standard",
  name: "standard",
  baseQuantities: [
    { ...Density },
    { ...Velocity, symbol: "u" },
    { ...Length, name: "linear_dimension", selectedUnit: "mm", symbol: "L" },
    { ...Viscosity },
    { ...UnitLess, name: "reynolds", symbol: "Re" },
  ],
  equation: "Re=\u03C1*v*L/\u03BC",
};

export const reynoldsCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "reynolds",
  branch: "Fluids",
  difficulty: "intermediate",
  inputs: [standardMode],
  calculate: [
    {
      name: "standard",
      equations: [
        {
          target: "reynolds",
          expression:
            "(density) * (velocity) * (linear_dimension) / (viscosity)",
        },
        {
          target: "density",
          expression:
            "(reynolds) * (viscosity) / (velocity) / (linear_dimension)",
        },
        {
          target: "velocity",
          expression:
            "(reynolds) * (viscosity) / (density) / (linear_dimension)",
        },
        {
          target: "linear_dimension",
          expression: "(reynolds) * (viscosity) / (density) / (velocity)",
        },
        {
          target: "viscosity",
          expression:
            "(reynolds) / (density) / (velocity) / (linear_dimension)",
        },
      ],
    },
  ],
};
